<template>
    <div>
      <v-dialog v-model="dialog" persistent max-width="450px">
        <v-card>
          <v-card-title class="primary white--text">
            <h2 class="text-h5 font-weight-medium">Contato do Aluno</h2>
          </v-card-title>
          <v-card-text>
             <v-container pt-9 px-2 pb-2 fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="input-wraper mb-4">
                    <label>Aluno:</label>
                    <span>{{ aluno | capitalize }}</span>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <div class="input-wraper mb-4">
                    <label>Responsável:</label>
                    <span>{{ responsavel | capitalize }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="input-wraper mb-4 mr">
                    <label>Fixo 1:</label>
                    <span>{{ fixo1 | telefone }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="input-wraper  mb-4 ml">
                    <label>Fixo 2:</label>
                    <span>{{ fixo2 | telefone }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="input-wraper  mb-4 mr">
                    <label>Celular 1:</label>
                    <span>{{ celular1 | telefone }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="input-wraper  mb-4 ml">
                    <label>Celular 2:</label>
                    <span>{{ celular2 | telefone }}</span>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <div class="input-wraper">
                    <label>E-mail do responsável:</label>
                    <span>{{ email ? email : 'Não cadastrado' }}</span>
                    <label>E-mail do aluno:</label>
                    <span>{{ emailaluno ? emailaluno : 'Não cadastrado' }}</span>
                  </div>
                </v-flex>
              </v-layout>
             </v-container>
          </v-card-text>
          <v-card-actions>
            <div id="btn-acoes-b">
              <v-btn class="primary white--text mr-3 rounded-sm font-weight-regular" type="button" small @click="fecharDialog">Fechar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Layout from '@/views/Layout.vue';

const AlunoRepository = RepositoryFactory.get('aluno');

export default {
  name: 'contato-aluno',
  props: {
    cdtipesc:{
      type: [String, Number],
      default: null,
    },
    cdescola:{
      type: [String, Number],
      default: null,
    },
    numatalun:{
      type: [String, Number],
      default: null,
    },
    dialog:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return{
      aluno: "",
      responsavel: "",
      fixo1: null,
      fixo2: null,
      celular1: null,
      celular2: null,
      email: null,
      emailaluno: null,
    };
  },
  methods: {
    fecharDialog(){
      this.$emit('update:dialog', false)
    },
    limparDados() {
      this.aluno = "";
      this.responsavel = "";
      this.fixo1 = null;
      this.fixo2 = null;
      this.celular1 = null;
      this.celular2 = null;
      this.email = null;
      this.emailaluno = null;
    }
  },
  watch: {
    numatalun: async function (newVal, oldVal) {
      this.$Progress.start();

      if( newVal != oldVal ) {
        this.limparDados();
        try {
          const {data} = await AlunoRepository.getContatoAluno( { cdtipesc: this.cdtipesc, cdescola: this.cdescola, numatalun: this.numatalun } );

          this.aluno = data.aluno.nmaluno;
          this.responsavel = data.nmrespon;
          this.fixo1 = data.aluno.edtelefdd;
          this.fixo2 = data.aluno.edtelfx2;
          this.celular1 = data.aluno.edtelcel1;
          this.celular2 = data.aluno.edtelcel2;
          this.email = data.aluno.edemailresp;
          this.emailaluno = data.aluno.edemailalu;
        }
        finally  {
          this.$Progress.finish();
        }
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      let words = value.toString().toLowerCase().split(' ');
      return words.map(word => word.charAt(0).toUpperCase() + word.slice(1) ).join(' ');
    },
    telefone: function (numero) {
      if (!numero) return 'Não cadastrado';
      numero = numero.toString();
      switch (numero.length) {
        case 8:
          return numero.substring(0, 4) + '-' + numero.substring(4, 8);
          break;
        case 9:
          return numero.substring(0, 1) + ' ' + numero.substring(1, 5) + '-' + numero.substring(5, 9);
          break;
        case 10:
          return '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 6) + '-' + numero.substring(6, 10);
          break;
        case 11:
          return '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 3) + ' ' + numero.substring(3, 7) + '-' + numero.substring(7, 11);
          break;
        default:
          return numero;
          break;
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .input-wraper {
    border-bottom: 1px solid cadetblue;
    label {
      color: cadetblue;
      font-weight: bold;;
      display: block;
      margin-bottom: 4px;
    }
    span { color: darkslateblue; }
  }
  @media screen and (min-width: 600px) {
    .mr { margin-right: 13px; }
    .ml { margin-left: 13px;;}
  }
  #btn-acoes-b {
    position: relative;
    width: 100%;
    border-radius: 0px;
    text-align: right;
  }
</style>
